import styled, { css } from 'styled-components';
import { cond, propEq, always, T } from 'ramda';

import { media } from '../../utils/media';

export const HeaderColumn = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.43em;
  letter-spacing: 0.35px;
  padding: 12px 20px;

  ${cond([
    [
      propEq('column', 'PAPER'),
      always(css`
        width: 100%;

        ${media.tablet`
        width: 25%;
      `}
      `),
    ],
    [
      T,
      always(css`
        display: none;

        ${media.tablet`
        display: block;
        width: 25%;
      `}
      `),
    ],
  ])}
`;

const cellStyle = css`
  line-height: 2em;
  letter-spacing: 0.3px;
  font-size: 12px;
  padding: 12px 20px;
`;

export const Row = styled.div`
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.color};
  background-color: ${({ useColor, theme }) => useColor && theme.background};
  flex-direction: column;

  ${media.tablet`
    flex-direction: row;
  `}
`;

export const RowHeader = styled.div`
  ${cellStyle}
  text-transform: uppercase;
  font-weight: 600;
  color: ${({ theme }) => theme.color};
  width: 100%;
  cursor: pointer;

  ${media.tablet`
    font-weight: 500;
    width: 25%;
    cursor: default;
  `}
`;

export const RowContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  overflow: hidden;
  transition: height 0.3s;
  height: 0;

  ${media.tablet`
    width: 75%;
    flex-direction: row;
    height: auto !important;
  `}
`;

export const Cell = styled.div`
  ${cellStyle}
  flex: 0 0 auto;
  width: 100%;

  &:before {
    content: '${({ column }) => column}';
    color: ${({ theme }) => theme.color};
    display: block;
    font-weight: 500;
    font-size: .9em;
  }

  ${media.tablet`
    width: calc(100% / 3);

    &:before {
      display: none;
    }
  `}

`;
